import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "card-expanding",
  templateUrl: "./card-expanding.component.html",
  host: { 'class': 'card', '[class.expanded]': 'expanded' }
})
export class CardExpandingComponent {

  @Input() public expanded = true;
  @Output() expandedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() public valid: boolean = null;
  @Output() public onExpand = new EventEmitter();

  @Input() public showArrow = true;
  @Input() public isSmallArrow = false;
  @Input() public hideActionsWhenCollapsed = true;

  constructor() { }

  public toggleExpand() {
    this.expanded = !this.expanded;
    this.onExpand.emit(this.expanded);
    this.expandedChange.emit(this.expanded);
  }

}
